import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.projetos.erpworks.com.br:3334',
  // baseURL: 'http://api.srv882033.hstgr.cloud:3334',
  // baseURL: 'http://localhost:3334',
  // baseURL: 'http://187.77.234.127:3335',
  // baseURL: '/api',
});

export default api;
